import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { toOptions } from '../../../../../../utils/toOptions';
import { useGetPoolOptions } from '../../../../Tables/Settings/PlanUnits/components/utils/useGetPoolOptions';

import {
  useGetClusters,
  useGetContracts,
  useGetEmployees
} from '../../../../../../queries';
import { ControlledDatePicker, ControlledSelect } from '../../../../../shared';

const BenefitsSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control } = useFormContext();
  const { data: pools } = useGetPoolOptions();
  const { data: clusters } = useGetClusters();
  const { data: contracts } = useGetContracts();
  const { data: employees } = useGetEmployees();

  return (
    <>
      <ControlledDatePicker
        fullWidth
        variant="outlined"
        control={control}
        name="valid_from"
        label={t('validFrom')}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="emp_id_list"
        label={t('employee')}
        options={employees ?? []}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="pool_list"
        label={t('pool')}
        options={pools}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cluster_list"
        label={t('cluster')}
        options={toOptions(clusters ?? [], 'clusterId', 'name')}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="contract_list"
        label={t('contract')}
        options={contracts ?? []}
      />
    </>
  );
};

export default BenefitsSection;
